import { DateStringResourceParam, UuidResourceParam, uuidSerializer } from "@legacy-megarax/common";
import { BaseResource, IdResourceParam, ResourceActionV2 } from "@legacy-megarax/rest-resource";
import { MSerializers } from "@legacy-megarax/serializers";

import { FixedRouteFilters } from "./";
import { dayDtoSerializer } from "./dayDto";
import { changeVisitDurationErrors, descheduleVisitErrors, loadFixedRouteErrors, scheduleVisitErrors } from "./errors";
import { fixedRouteSimpleSerializers } from "./fixedRoute";
import { scheduleVisitInputSerializer } from "./inputs";

export const visitScheduleDayResource = BaseResource(["crm", "visitScheduleDays"], {
  byUserId: IdResourceParam("userId", {
    byDate: DateStringResourceParam("date", "date", {
      retrieve: ResourceActionV2({
        name: "retrieve",
        method: "get",
        path: "",
        responseValueSerializer: dayDtoSerializer.nullable(),
      }),

      loadFixedRoute: ResourceActionV2({
        name: "loadFixedRoute",
        method: "post",
        requestBodySerializer: MSerializers.object({
          routeUuid: uuidSerializer,
        }),
        responseErrorSerializer: MSerializers.stringOneOf(...loadFixedRouteErrors),
      }),

      byVisitUuid: UuidResourceParam("visitUuid", "visits", {
        schedule: ResourceActionV2({
          name: "scheduleVisit",
          method: "post",
          path: "",
          requestBodySerializer: scheduleVisitInputSerializer,
          responseErrorSerializer: MSerializers.stringOneOf(...scheduleVisitErrors),
        }),
        deschedule: ResourceActionV2({
          name: "descheduleVisit",
          method: "delete",
          path: "",
          responseErrorSerializer: MSerializers.stringOneOf(...descheduleVisitErrors),
        }),
        changeDuration: ResourceActionV2({
          name: "changeVisitDuration",
          method: "put",
          path: "changeDuration",
          requestBodySerializer: MSerializers.object({
            durationMinutes: MSerializers.integer,
          }),
          responseErrorSerializer: MSerializers.stringOneOf(...changeVisitDurationErrors),
        }),
      }),
    }),
  }),
});

const fixedRouteListAction = ResourceActionV2({
  name: "list",
  method: "get",
  path: "",
  querySerializer: MSerializers.object<FixedRouteFilters>({
    userId: MSerializers.integer.optional(),
  }),
  responseValueSerializer: MSerializers.array(fixedRouteSimpleSerializers),
});

export const fixedRouteResource = BaseResource(["crm", "fixedRoutes"], {
  list: fixedRouteListAction,
});
